<div class="main-content-container">
  <div class="page-title-container d-flex">
    <div class="page-title flex-grow-1">
      @if (action === 'MODIFY') {
        <span>Change Password</span>
      }
    </div>
  </div>
  @if (currentFields.blocks) {
    <div class="main-container-body">
      <div class="main-box-shadow app-ui-engine-container">
        @if (action === 'MODIFY') {
          <dhs-form [action]="action" [fieldGroup]="currentFields" [config]="config"
            (saveFinished)="onSaveFinished($event)" (cancel)="cancelButtonClick()">
          </dhs-form>
        }
      </div>
    </div>
  }
</div>